import actions from './actions'
import mutations from './mutations'
import getters from './getters'
export default {
  namespaced: true,
  state: {
    classItems: [],
    posts: [],
    files: [],
    assignments: []
  },
  actions,
  mutations,
  getters 
}


// WEBPACK FOOTER //
// ./src/store/Instructor/index.js